import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALITYASSET,
  DELETE_LEGALITYASSET,
  UPDATE_LEGALITYASSET,
  ADD_NEW_LEGALITYASSET,
} from "./actionType";

import {
  getLegalityAssetSuccess,
  getLegalityAssetFail,
  deleteLegalityAssetSuccess,
  deleteLegalityAssetFail,
  updateLegalityAssetSuccess,
  updateLegalityAssetFail,
  addLegalityAssetSuccess,
  addLegalityAssetFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalityAssetApi,
  updateLegalityAssetApi,
  deleteLegalityAssetApi,
  addNewLegalityAssetApi
} from "../../helpers/backend_helper";

function* getLegalityAsset({ payload: legalityAsset }) {
  try {
    const response = yield call(getLegalityAssetApi, legalityAsset);
    yield put(getLegalityAssetSuccess(GET_LEGALITYASSET, response.data));
  } catch (error) {
    yield put(getLegalityAssetFail(GET_LEGALITYASSET, error));
  }
}

function* onUpdateLegalityAsset({ payload: legalityAsset }) {
  try {
    const response = yield call(updateLegalityAssetApi, legalityAsset);
    yield put(updateLegalityAssetSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalityAssetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalityAsset({ payload: legalityAsset }) {
  try {
    const response = yield call(deleteLegalityAssetApi, legalityAsset);
    yield put(deleteLegalityAssetSuccess({ legalityAsset, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalityAssetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalityAsset({ payload: legalityAsset }) {
  try {
    const response = yield call(addNewLegalityAssetApi, legalityAsset);
    yield put(addLegalityAssetSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalityAssetFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalityAsset() {
  yield takeEvery(GET_LEGALITYASSET, getLegalityAsset);
}

export function* watchUpdateLegalityAsset() {
  yield takeEvery(UPDATE_LEGALITYASSET, onUpdateLegalityAsset);
}

export function* watchDeleteLegalityAsset() {
  yield takeEvery(DELETE_LEGALITYASSET, onDeleteLegalityAsset);
}

export function* watchAddNewLegalityAsset() {
  yield takeEvery(ADD_NEW_LEGALITYASSET, onAddNewLegalityAsset);
}

function* legalityAssetSaga() {
  yield all([
    fork(watchGetLegalityAsset),
    fork(watchDeleteLegalityAsset),
    fork(watchUpdateLegalityAsset),
    fork(watchAddNewLegalityAsset)
  ]);
}

export default legalityAssetSaga;
